import { BreadCrumb } from 'primereact/breadcrumb';
import { MenuItem, MenuItemCommandEvent } from 'primereact/menuitem';
import { Skeleton } from 'primereact/skeleton';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './ComponentBreadCrumb.module.css';

type ComponentBreadCrumbProps = {
  isLoading?: boolean;
  componentName?: string;
};

const ComponentBreadCrumb = ({
  isLoading,
  componentName,
}: ComponentBreadCrumbProps): JSX.Element => {
  const location = useLocation();
  const { t } = useTranslation();

  const navigate = useNavigate();

  const home: MenuItem = {
    label: t('componentDetailsPage.breadcrumb.components'),
    className: styles['home-item'],
    command: (e: MenuItemCommandEvent) => {
      e.originalEvent.preventDefault();

      const previousPath = (location.state?.from as string) ?? '';

      if (previousPath.includes('/components')) {
        navigate(location.state?.from);
      } else {
        navigate('/components');
      }
    },
  };
  const items = [{ label: componentName, disabled: true }];

  if (isLoading) {
    return <Skeleton height='1.5rem' className='w-8 md:w-2' />;
  }

  return <BreadCrumb model={items} home={home} className='bg-transparent border-none p-0' />;
};

export default ComponentBreadCrumb;
